import { readOrganizationModels } from 'serviceWorker/broadcasts/organization/all';
import { createEntitySource } from 'serviceWorker/channelServers/entitySource';
import type { ServiceData } from 'serviceWorker/db/service';
import * as dbOrganizations from 'serviceWorker/db/organizations/organizations';
import * as dbOrganizationsService from 'serviceWorker/db/organizations/organizationsService';
import { organizationContract } from 'shared/domain/organization/organizationContract';
import { organizationsSync } from './index';

/**
 * The download state of the organizations, not downloaded when the table is
 * empty: a project switch used to clear the rows and keep the service
 * downloaded, and a read, which does not sync, never brought them back.
 */
export const organizationDownloadState = {
  get: async (): Promise<ServiceData | undefined> => {
    const [serviceData, organizations] = await Promise.all([dbOrganizationsService.get(), dbOrganizations.get()]);
    return serviceData?.isDownloaded && organizations.length === 0 ? { ...serviceData, isDownloaded: false } : serviceData;
  },
  stopDownloading: dbOrganizationsService.stopDownloading,
};

/**
 * Organizations of IndexedDB. A read answers with the stored ones and syncs
 * them afterwards: they belong to the user and outlive page reloads and
 * project switches, so without it a change made elsewhere (e.g. a new logo)
 * reached the page only after a logout.
 */
export const organizationSource = createEntitySource({
  service: organizationDownloadState,
  contract: organizationContract,
  ...organizationsSync,
  readAll: readOrganizationModels,
});
